import React, { useEffect, useState, useRef } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import { Tr, Td, Label, Input } from './css';
import getFormattedPricing from '../../utils';
import FieldGuide from '../../../../form/fields/common/fieldGuide';

const Row = ({ rowData, viewType, service, setService }) => {
  const {
    fields: { addonName, unitPrice, toolTip }
  } = rowData;

  const [quantity, setQuantity] = useState(() =>
    _.get(service, `${addonName}.quantity`, 0)
  );
  const isComponentMounted = useRef(false);
  const rowRef = useRef(false);

  const handleQuantityChange = e => {
    const {
      target: { value }
    } = e;
    setQuantity(+value);
  };

  useEffect(() => {
    if (!isComponentMounted.current) {
      isComponentMounted.current = true;
      return;
    }

    setService(previousValue => {
      const updatedRatePlans = {
        ...previousValue,
        [addonName]: {
          quantity,
          unitPrice
        }
      };
      return updatedRatePlans;
    });
  }, [quantity, unitPrice]);

  useEffect(() => {
    if (viewType && rowRef.current) {
      setQuantity(0);
    }
    rowRef.current = true;
  }, [viewType]);

  return (
    <Tr>
      <Td style={{ background: '#f7f7f7', fontWeight: '700' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%' }}>
          <Label>{addonName}</Label>
          {toolTip && (
            <div style={{ display: 'inline-flex', alignItems: 'center' }}>
              <FieldGuide tooltip={toolTip} />
            </div>
          )}
        </div>
      </Td>
      <Td>
        <Input
          className="frg-input-field color-light"
          pattern="[0-9]"
          value={quantity}
          onChange={handleQuantityChange}
        />
      </Td>
      <Td>
        <Label>{getFormattedPricing(unitPrice)}</Label>
      </Td>
      <Td>
        <Label>{getFormattedPricing(unitPrice * quantity)}</Label>
      </Td>
    </Tr>
  );
};

Row.propTypes = {
  rowData: PropTypes.shape({
    fields: PropTypes.shape({
      addonName: PropTypes.string,
      unitPrice: PropTypes.number,
      toolTip: PropTypes.string
    })
  }).isRequired,
  viewType: PropTypes.string.isRequired,
  service: PropTypes.shape({}).isRequired,
  setService: PropTypes.func.isRequired
};

export default Row;
